import { DownloadOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu } from 'antd';
import React from 'react';
import OWButtonWithSupplierManagedLock from '../../common/OWButtonWithSupplierManagedLock';

export default function RightActions({ downloadCSV }) {
	return (
		<>
			<OWButtonWithSupplierManagedLock
				size="large"
				icon={<DownloadOutlined translate="" />}
				className="inline-block-visible-md"
				onClick={downloadCSV}
			>
				<span className="inline-block-visible-xxl">Export CSV</span>
			</OWButtonWithSupplierManagedLock>
		</>
	);
}
